var render = function render(){var _vm=this,_c=_vm._self._c;return _c('user-work-relationship-page-content',{ref:"content",attrs:{"relationship":_vm.USER_WORK_RELATIONSHIPS.SAVED_FOR_LATER}})
}
var staticRenderFns = []

export { render, staticRenderFns }